import { maxBookableDate, type BookingHorizonDays } from "@/lib/booking-horizon";
import { earliestBookableDate } from "@/lib/booking-lead-time";

export interface ScheduleOverviewRules {
  availableDays: number[];
  blockedDates: string[];
  addedDates: string[];
  bookingHorizonDays: number | null;
  minBookingLeadDays: number;
}

export function toLocalDateString(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function isDateAllowedByScheduleOverview(
  date: Date,
  today: Date,
  rules: ScheduleOverviewRules,
): boolean {
  const dateString = toLocalDateString(date);
  const minDate = earliestBookableDate(rules.minBookingLeadDays, today);
  if (dateString < minDate) return false;

  const horizon = rules.bookingHorizonDays as BookingHorizonDays | null;
  const maxDate = maxBookableDate(horizon, today);
  if (maxDate && dateString > maxDate) return false;

  const blockedDates = new Set(rules.blockedDates);
  if (blockedDates.has(dateString)) return false;

  const addedDates = new Set(rules.addedDates);
  if (addedDates.has(dateString)) return true;

  const availableDays = new Set(rules.availableDays);
  return availableDays.has(date.getDay());
}
